import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  API_PATH_DIALED_DIGIT_EXTRACTION_SERVER,
  DialedDigitExtractionServer,
} from './dialedDigitExtractionServer.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getDialedDigitExtractionServerList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<DialedDigitExtractionServer>> {
  return http.get(`${API_PATH_DIALED_DIGIT_EXTRACTION_SERVER}/${deliveryFunctionId}`);
}

export function getDialedDigitExtractionServer(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<DialedDigitExtractionServer>> {
  return http.get(`${API_PATH_DIALED_DIGIT_EXTRACTION_SERVER}/${deliveryFunctionId}/${id}`);
}

export function createDialedDigitExtractionServer(
  deliveryFunctionId: string,
  body: WithAuditDetails<DialedDigitExtractionServer>,
): AxiosPromise<ServerResponse<DialedDigitExtractionServer>> {
  return http.post(`${API_PATH_DIALED_DIGIT_EXTRACTION_SERVER}/${deliveryFunctionId}`, body);
}

export function updateDialedDigitExtractionServer(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<DialedDigitExtractionServer>,
): AxiosPromise<ServerResponse<DialedDigitExtractionServer>> {
  return http.put(`${API_PATH_DIALED_DIGIT_EXTRACTION_SERVER}/${deliveryFunctionId}/${id}`, body);
}

export function deleteDialedDigitExtractionServer(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<DialedDigitExtractionServer>> {
  return http.delete(`${API_PATH_DIALED_DIGIT_EXTRACTION_SERVER}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
